import { Loader2 } from 'lucide-react';
import type { JSX } from 'react';
import { cn } from '@/lib/cn.js';

export interface SpinnerProps {
  className?: string;
  /** Texte pour lecteurs d'écran ; l'icône seule est `aria-hidden`. */
  label?: string;
}

export function Spinner({ className, label = 'Chargement…' }: SpinnerProps): JSX.Element {
  return (
    <span role="status" className="inline-flex items-center gap-2 text-muted-foreground">
      <Loader2 className={cn('size-4 animate-spin', className)} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
